// @spec POL-STR-027
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ScanResultsPage } from '@/features/policies/components/ScanResultsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/policies/$policyId/scans/$scanId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.scanResults'),
  }),
  component: ScanResultsRoute,
});

/**
 * Scan results route - Full-page compliance scan results view.
 *
 * Displays:
 * - Regulation name, status, and coverage metrics
 * - Findings grouped by requirement category
 * - Policy excerpt highlighting
 * - Re-scan and back navigation
 */
function ScanResultsRoute() {
  const { policyId, scanId } = Route.useParams();

  return <ScanResultsPage policyId={policyId} scanId={scanId} />;
}
